// marketing-site/src/App.jsx
import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import LandingPage from './pages/LandingPage'; // Agora é V2
import CoachLandingPage from './pages/CoachLandingPage';
import CoachDemoLandingPage from './pages/CoachDemoLandingPage';
import SupportPage from './pages/SupportPage';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage';
import TermsOfServicePage from './pages/TermsOfServicePage';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Atletas */}
        <Route path="/" element={<LandingPage />} />
        <Route path="/atletas" element={<LandingPage />} />
        <Route path="/runners" element={<LandingPage />} />
        <Route path="/v2" element={<Navigate to="/" replace />} />

        {/* Treinadores — /coaches é a rota canônica (funil vivo; não substituir pela demo) */}
        <Route path="/coaches" element={<CoachLandingPage />} />
        <Route path="/treinadores" element={<CoachLandingPage />} />
        <Route path="/coaches-v2" element={<Navigate to="/coaches" replace />} />

        {/* Demo da porta de treinador — revisão do PO; não é o funil publicado */}
        <Route path="/treinadores-demo" element={<CoachDemoLandingPage />} />
        <Route path="/coaches-demo" element={<CoachDemoLandingPage />} />

        {/* Institucional */}
        <Route path="/support" element={<SupportPage />} />
        <Route path="/help" element={<SupportPage />} />
        <Route path="/privacy" element={<PrivacyPolicyPage />} />
        <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
        <Route path="/terms" element={<TermsOfServicePage />} />
        <Route path="/terms-of-service" element={<TermsOfServicePage />} />

        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
